// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/pattern.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  text-decoration: none;
}
.layout-main {
  /* display: flex; */
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background-color: #fbfcfd;
}
.layout-main .sider {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 265px;
  height: 100vh;
  background: #fff;
  box-shadow: rgb(113 122 131 / 11%) 0px 7px 30px 0px;
  z-index: 9;
}
.layout-main .content-part {
  display: flex;
  flex: 1 1 auto;
  background: #fbfcfd;
  flex-direction: column;
}
.layout-main .content-part .header-part {
  display: flex;
  width: 100%;
  height: 80px;
  background: white;
  box-shadow: rgb(113 122 131 / 11%) 0px 7px 30px 0px;
  padding-left: 265px;
  position: relative;
  top: 0;
}
.layout-main .content-part .content {
  width: 100%;
  padding-left: 265px;
  max-height: 100vh;
  /* margin-top: 80px; */
  /* margin-bottom:80px; */
  overflow-y: scroll;
}

.main-content-part {
  padding: 30px 30px 30px 30px;
  /* height: 80vh; */
  /* max-height:100vh;
    overflow: scroll; */
  margin-bottom: 5rem !important;
}
.main-content-part.excersiceList {
  padding: 35px 0;
}
.main-content-part.excersiceList .exercise-tab-part {
  padding: 0 70px 0 35px;
}
.button-part {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.theme-outline-btn {
  font-size: 16px;
  border-radius: 28px;
  min-width: 300px;
  padding: 14px;
  border: 1px solid #ff6036;
  background-color: transparent;
  color: #ff6036;
  font-weight: 600;
}
.theme-outline-btn:hover {
  background-color: #ff6036cf !important;
  box-shadow: none;
  border-color: #ff6036;
  color: #fff;
}
.theme-button {
  background-color: #ff6036;
  font-size: 14px;
  border-radius: 28px;
  min-width: 300px;
  padding: 14px;
  font-weight: 600;
  border: none;
}
.theme-button:hover,
.theme-button:focus,
.btn:focus-visible {
  background-color: #ff6036cf !important;
  box-shadow: none;
  border-color: #ff6036;
}

.secondary-button {
  background-color: #a8a8a8;
  font-size: 16px;
  border-radius: 28px;
  min-width: 300px;
  padding: 14px;
  font-weight: 600;
}
.secondary-button:hover,
.theme-button:focus,
.btn:focus-visible {
  background-color: #a8a8a8 !important;
  box-shadow: none;
  border-color: #a8a8a8;
}

.theme-button span {
  font-weight: 500;
}
/* modal css */
.modal-content {
  border-radius: 12px;
  border: 1px solid #707070;
  padding: 20px 30px;
}
.btn-close {
  position: absolute;
  right: 15px;
  top: 13px;
}
.modal-header {
  text-align: center;
  justify-content: center;
  border-bottom: 1px solid #eaeaea;
  padding: 0;
}
.modal-header .modal-title {
  font-size: 22px;
  font-weight: 500;
  padding-bottom: 24px;
}
.modal-body {
  border: 0;
  padding: 24px 0;
}
.body-content .body-title {
  font-size: 16px;
  font-weight: 500;
}
textarea.form-control {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  padding: 18px;
}
textarea.form-control:focus {
  box-shadow: none;
  border-color: #eaeaea;
}
.modal-footer {
  border: 0;
  flex-direction: column;
  justify-content: center;
}
.modal-content .theme-button {
  min-width: 250px;
  padding: 8px;
}
.modal-content .footerLink {
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  color: #1d2432;
}
.file-area {
  width: 100%;
  position: relative;
  border: 1px dashed #1d2432;
  border-radius: 8px;
  height: 150px;
}
.file-area input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
}
.file-area .file-dummy {
  width: 100%;
  padding: 30px;
  background: rgba(255, 255, 255, 0.2);
  /* border: 2px dashed rgba(255, 255, 255, 0.2); */
  height: 150px;
  text-align: center;
  transition: background 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
}
.file-area .file-dummy .success {
  display: none;
}
.file-area:hover .file-dummy {
  background: rgba(255, 255, 255, 0.1);
}
.file-area input[type="file"]:focus + .file-dummy {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline: -webkit-focus-ring-color auto 5px;
}
.file-area input[type="file"]:valid + .file-dummy {
  border-color: rgb(248 212 203 / 23%);
  background-color: rgb(248 212 203 / 23%);
}
.file-area input[type="file"]:valid + .file-dummy .success {
  display: inline-block;
}
.file-area input[type="file"]:valid + .file-dummy .default {
  display: none;
}

/* progressbar */

.progressBar .progressText {
  display: flex;
  justify-content: space-between;
}

.progressBar .progressText p {
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 6px;
  color: #1d2432;
}
.progressBar .progress {
  height: 10px;
  background-color: #fdf5f2;
  border-radius: 14px;
}
.progressBar .progress .progress-bar {
  background-color: #ff6036;
  border-radius: 14px;
}

/* searchpart */
.serchPart .searchInput input {
  border-radius: 46px;
  box-shadow: 0px 1px 15px #0000000f;
  padding: 15px 10px 15px 82px;
  font-size: 18px;
  font-weight: 400;
  border: 0;
  width: 100%;
}
.serchPart .searchInput {
  display: flex;
  justify-content: center;
  width: 70%;
  position: relative;
  /* margin: 0 auto 35px; */
}
.serchPart .searchInput .searchIcon {
  position: absolute;
  left: 30px;
  top: 17px;
}
.serchPart .searchInput .filterIcon {
  position: absolute;
  right: 24px;
  top: 17px;
  cursor: pointer;
}
.serchPart .searchInput input:focus {
  outline: 0;
}
/* note-part */
.note-part {
  background-color: #fdf5f3;
  color: #ff6036;
  padding: 30px;
}

/* form-data */
.form-data.full-width-data {
  max-width: 90%;
}
.form-data .title {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 35px;
}
.form-data {
  max-width: 70%;
  margin: auto;
}
.form-data .filed {
  margin-bottom: 15px;
}
.form-data .filed label {
  font-size: 14px;
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
}
.form-data .filed input,
.form-select {
  border: 1px solid #eaeaea;
  border-radius: 8px;
  padding: 15px;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
}

input:focus {
  outline: none;
}
/* .form-select:focus{
  box-shadow: none;
  border: 1px solid #EAEAEA;
} */
/* yes-no-radio */

.yes-no-radio {
  display: flex;
  gap: 15px;
}
.yes-no-radio input[type="radio"] {
  display: none;
}
.yes-no-radio input[type="radio"]:checked + .box {
  background-color: transparent;
  border: 1px solid #ff6036;
}
.yes-no-radio input[type="radio"]:checked + .box span {
  color: #ff6036;
}
.yes-no-radio .box {
  border: 1px solid #eaeaea;
  padding: 16px 20px;
  border-radius: 8px;
  background-color: #fff;
  transition: all 250ms ease;
  will-change: transition;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-size: 14px;
  font-weight: 400;
  min-width: 150px;
}
.yes-no-radio .box span {
  transform: translate(0, 60px);
  left: 0;
  right: 0;
  transition: all 300ms ease;
  font-size: 1.5em;
  -webkit-user-select: none;
          user-select: none;
  color: #1d2432;
}
.timer-block .yes-no-radio label {
  margin-bottom: 0;
}
.timer-block .yes-no-radio .box {
  min-width: 60px;
  padding: 10px 12px;
}

.myProfileCard {
  display: flex;
  justify-content: center;
  gap: 15px;
  align-items: center;
}

.myProfileCard > h6 {
  font-size: 14px;
  font-weight: normal;
  color: black !important;
}

.light-text {
  color: #adadad;
}
.btn-theme-bg {
  background: #ff623610 0% 0% no-repeat padding-box;
  border-radius: 26px;
  color: #ff6036;
  font: normal normal medium 17px/26px Poppins;
}
.btn-theme-bg > svg > path,
.btn-theme-bg > svg > g > path {
  fill: #ff6036;
}

.printBtn {
  font-size: 14px;
  border-radius: 1px;
  min-width: 45px;
  padding: 7px;
  border: 1px solid #eaeaea;
  background-color: transparent;
  color: #ff6036;
  font-weight: 500;
}

.printBtn:hover {
  color: white;
  background-color: #ff6036;
  border-color: #ff6036;
}

.printBtnn > svg > path {
  fill: white;
}
.printBtnn:hover > svg > path {
  fill: #ff6036;
}
.printBtnn {
  font-size: 14px;
  border:1px solid #eaeaea;
  min-width: 45px;
  padding: 7px;
  border-color: #ff6036;
  background-color: #ff6036;
  font-weight: 500;
  color: white;
}

.printBtnn:hover {
  color: #ff6036;
  background-color: transparent;
  border: 1px solid #eaeaea;
}

.highlightOption {
  background: #ff6036 !important;
  color: #fff;
}
.option {
  font-size: 14px !important;
}
.notFound {
  font-size: 14px !important;
}
.option:hover {
  background: #ff6036 !important;
  color: #fff;
}
.icon_down_dir:before {
  content: "" !important;
}
.multiSelectContainer input {
  font-size: 14px !important;
}
.chip {
  align-items: center;
  background: #ff6036 !important;
  border-radius: 11px;
  color: #fff;
  display: inline-flex;
  font-size: 13px;
  line-height: 19px;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 4px 10px;
}
.printBtn:hover > svg > path,
.printBtn:hover > a > svg > path {
  fill: white;
}

/* Example CSS styles */
.content-container {
  max-width: 40%; /* Adjust as needed */
}

@media (max-width: 768px) {
  .content-container {
    max-width: 100%; /* Full width on smaller screens */
  }
}

.filed > label {
  font-size: 14px;
}
.checkbox > span {
  font-size: 14px;
}
/* .searchWrapper {
   border: none !important; 
} */
/* Base style for the checkmark */
.radio-container .checkmark {
  display: inline-block;
  height: 25px;
  width: 25px;
  background-color: #f2f2f2;
  border-radius: 50%;
  position: relative;
  border: 1px solid #d9d9d9;
}

/* Hide the checkmark by default */
.radio-container .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* When the associated radio input is checked, change the checkmark background and border color */
.radio-container input[type="radio"]:checked + .checkmark {
  background-color: #ff6036;
  border-color: #ff6036;
}

/* Style the checkmark indicator */
.radio-container input[type="radio"]:checked + .checkmark:after {
  display: block;
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.radio-container input[type="radio"] {
  display: none;
}

.no-block {
  display: flex;
  min-width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #adadad;
  color: #fff;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.info-section {
  display: flex;
  /* align-items: center; */
  /* margin-bottom: 10px; */
  font-size: 14px;
}

.label {
  min-width: 100px; /* Adjust as needed */
  font-weight: bold;
  font-size: 14px;
}

.data {
  flex-grow: 1;
  font-size: 14px;
}

.cardFromPrice {
  background-color: white;
  color: black;
  border-radius: 14px;
  border: none;
}
.cardFromPrice:hover {
  background-color: #ff6036;
  color: white !important;
  cursor: pointer;
}
.cardFromPriceSelected {
  background-color: #ff6036;
  color: white !important;
  cursor: pointer;
}

.cardFromPriceSelected  .select-btn {
  background-color: #fff; /* New background color */
  color: #ff6036; /* New text color */
}
.cardFromPrice:hover .select-btn {
  /* Styles to apply to .select-btn on hover of .cardFromPrice */
  /* Example: change background and text color */
  background-color: #fff; /* New background color */
  color: #ff6036; /* New text color */
  /* Add other properties and values as needed */
}

.cardFromPrice:hover .successIcon  {
  color: #ff6036; /* New text color */
  background-color: white;
}
.cardFromPrice:hover .failureIcon  {
  color: #000000; /* New text color */
  background-color: white;
}
.cardFromPrice:hover .price {
  color: white;
}

.cardFromPrice:hover .priceSub {
  color: white;
}

.cardFromPrice:hover .priceData{
  color:white
}


.cardFromPriceSelected .successIcon  {
  color: #ff6036; /* New text color */
  background-color: white;
}
.cardFromPriceSelected .failureIcon  {
  color: #000000; /* New text color */
  background-color: white;
}
.cardFromPriceSelected .price {
  color: white;
}

.cardFromPriceSelected .priceSub {
  color: white;
}

.cardFromPriceSelected .priceData{
  color:white
}
.iconTd{
  display: inline-block;
  align-items: center;
}
.priceData{
  color: gray;
}
.priceTitle {
  font-weight: 400;
  font-size: 20px;
}
.price {
  font-size: 24px;
  color: #000000;
  font-weight: bold;
}

.priceSub {
  font-size: 20px;
  color: #000000;
  font-weight: 400;
}
.check-icon {
  color: #28a745;
  margin-right: 5px;
}

.features {
  margin: 15px 0;
}

.features li {
  margin: 10px 0;
  font-size: 12px;
  display: flex; /* Align icon with text */
}

.select-btn {
  background-color: #ff6036;
  color: white;
  border-radius: 10px;
  border: none;
  padding: 10px 50px;
  font-weight: 500;
}

.select-btn:hover {
  background-color: #e55a2f;
  color: white;
}

.successIcon {
  background-color: #d5ffe6;
  display: flex; /* Use flexbox to align items */
  align-items: center; /* Vertical alignment */
  justify-content: center; /* Horizontal alignment */
  width: 20px; /* Set a fixed width for the icon container */
  height: 20px; /* Set a fixed height for the icon container */
  border-radius: 50%;
  padding: 5px;
  margin-right: 10px; /* Right margin for spacing */
}
.failureIcon {
  background-color: #efefef;
  display: flex; /* Use flexbox to align items */
  align-items: center; /* Vertical alignment */
  justify-content: center; /* Horizontal alignment */
  width: 20px; /* Set a fixed width for the icon container */
  height: 20px; /* Set a fixed height for the icon container */
  padding: 5px;
  border-radius: 50%;
  margin-right: 10px; /* Right margin for spacing */
}
/* .carousel-indicators  {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 15px;
  height: 15px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ff6036;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: .5;
  transition: opacity .6s ease;
} */

.carousel-indicators .active {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 10px;
  height: 10px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ff6036;
  background-clip: padding-box;
  border-radius: 50%;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  transition: opacity .6s ease;
}

.carousel-indicators :not(.active) {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 10px;
  height: 10px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ff62367c;
  background-clip: padding-box;
  border-radius: 50%;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: .5;
  transition: opacity .6s ease;
}

.carousel-indicators {
  position: absolute;
  left: 0px;
  right: auto;
  top:20rem;
  bottom: 0px;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 0%;
  margin-bottom: 0rem;
  margin-left: 0%;
}

.faq > label > p {
    margin-top: auto;
    margin-bottom: 0rem;
    display: block;
    margin-block-start: 1.5em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

}

.faq-heading {
  font-weight: 400;
  font-size: 14px;
   -webkit-transition: text-indent 0.2s;
  text-indent: 20px;
  color: #000000;
  font-weight: 500;
}

.faq-text {
  font-weight: 400;
  color: #919191;
  width:95%;
  padding-left:20px;
  margin-bottom:30px;
}

.faq {
  width: 1000px;
  margin: 0 auto;
  /* background: white; */
  border-radius: 4px;
  position: relative;
  /* border: 1px solid #E1E1E1; */
}
.faq label {
  display: block;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: 56px;
  padding-top:1px;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  background-color:white;
  border-radius: 14px;
  color: #000000;
  font-weight: bolder;
  /* border-bottom: 1px solid #E1E1E1; */
}

.faq input[type="checkbox"] {
  display: none;
}

.faq .faq-arrow {
  width: 10px;
  height: 10px;
  background-color: #ff6036;
  border-radius: 50%;
  padding: 15px;
  transition: transform 0.8s;
  /* -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  border-top: 2px solid rgba(0, 0, 0, 0.33);
  border-right: 2px solid rgba(0, 0, 0, 0.33); */
  float: right;
  position: relative;
  top: -40px;
  right: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.faq .faq-arrow > i {
  color:white
}

 .faq input[type="checkbox"]:checked + label > .faq-arrow {
  transition: transform 0.8s;
  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transform: rotate(135deg);
}
 .faq input[type="checkbox"]:checked + label {
  display: block;
  background: rgba(255,255,255,255) !important;
  color: #4f7351;
  height: fit-content;
  transition: height 0.8s;
  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

 .faq input[type='checkbox']:not(:checked) + label {
  display: block;
  transition: height 0.8s;
  height: 60px;
  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

::-webkit-scrollbar {
  display: none;
}









:root{
  --white:#fff;
  --smoke-white:#f1f3f5;
  --blue:#FFEDE8;
}

.selector{
  position:relative;
  width:max-content;
  background-color:white;
  height:50px;
  display:flex;
  padding-left: 3rem;
  padding-right: 3rem;
  justify-content:center;
  align-items:center;
  border-radius:14px;
  /* box-shadow:0 0 16px rgba(0,0,0,.2); */
}
.selector-item{
  position:relative;
  flex-basis:calc(70% / 3);
  height:100%;
  display:flex;
  justify-content:center;
  align-items:center;
}
.selector-item_radio{
  appearance:none;
  display:none;
}
.selector-item_label{
  position:relative;
  height:80%;
  width:fit-content;
  padding-left: 1rem;
  padding-right: 1rem;
  text-align:center;
  border-radius:14px;
  font-family: 'Poppins', sans-serif;
  font-weight:700;
  font-size: 14px;
  transition-duration:.5s;
  transition-property:transform, box-shadow;
  transform:none;white-space: nowrap; display: inline-block;
  align-items: center;
  display: flex;
    align-items: center;
}
.selector-item_radio:checked + .selector-item_label{
  background-color:var(--blue);
  color:black;
  /* box-shadow:0 0 4px rgba(0,0,0,.5),0 2px 4px rgba(0,0,0,.5); */
  transform:translateY(-2px);
}
@media (max-width:480px) {
.selector{
  width: 90%;
}
}



.advanced-needs-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ff6036;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: white;
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 20px;

  border-radius: 14px;
}

.advanced-needs-section-content {
  display: flex;
  flex-direction: column;
  justify-content: center; /* Centers content vertically within the content div */
  align-items: start; /* Aligns content to the start (left) within the content div */
  padding-left: 2rem;
}

.advanced-needs-section-content h2 {
  margin: 0; /* Removes default margin */
  font-size: 2em; /* Adjust font size as needed */
}

.advanced-needs-section .advanced-needs-section-content h2 {
  font-size: 2em; /* Adjust size as needed */
  margin-bottom: 0.5em;
}

.advanced-needs-section .advanced-needs-section-content button {
  background-color: black; /* Adjust button styling as needed */
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
}

.advanced-needs-section .image-container img {
  max-width: 100%;
  height: auto;
}

/* Responsive styling */
@media (max-width: 768px) {
  .advanced-needs-section {
    flex-direction: column;
    text-align: center;
  }

  .advanced-needs-section .image-container {
    margin-top: 20px;
  }
}




.price-table {
  width: 100%;
  /* border-collapse: collapse; */
  border: 0 none;
  border-collapse: separate;
    border-spacing: 10px; /* Adjust the value as needed */
}
.price-table tr:not(:last-child) {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.03);
}
.price-table tr td {
  /* border-left: 1px solid rgba(0, 0, 0, 0.05); */
  padding: 13px 30px;
  font-size: 14px;
  border: white 4px;
}


.price-table tr.price-table-head td  {
  font-size: 16px;
  font-weight: 500;
  padding: 0px 0px;
   margin: 3rem;
  /* font-family: "Montserrat"; */
  background-color: #FFEDE8;
  /* text-transform: uppercase; */

}
.price-table tr.price-table-head td:not(:first-child) {
  width: 18%;
}


.price-table tr td:first-child {
  border-left: 0 none;
}
.price-table tr td{
  text-align: center;
}
/* .price-table tr:nth-child(even) {
  background-color: #FFFFFF;
}
.price-table tr:hover {
  background-color: #EEEEEE;
} */
/* .price-table .fa-check {
  color: #397752;
} */
.price-table .fa-times {
  color: #D8D6E3;
}

.price-table tr td:nth-child(1) {
  /* background-color: rgba(216, 214, 227, 0.15); */
  text-align: left;
}
/* Highlighted column */
/* .price-table tr:nth-child(2n) td:nth-child(3) {
  background-color: rgba(216, 214, 227, 0.25);
} */
.price-table tr td:nth-child(3) {
  /* background-color: rgba(216, 214, 227, 0.15); */
  padding: 8px 48px;
}
.price-table tr td:nth-child(3) .fa-check,
.price-table tr:nth-child(2n) td:nth-child(3) .fa-check {
  /* color: #ffffff; */
}
/**/

.price-table > td {
  margin: 3rem;
}
.price-table tr.price-table-head td>span {
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  display: block;
  /* font-family: "Montserrat"; */
  background-color: #FFEDE8;
  /* text-transform: uppercase; */
}
.price-table tr.price-table-head {
  /* background-color: #5336ca; */
  color: black;
}
.price-table td.price {
  color: #f43f54;
  padding: 16px 24px;
  font-size: 20px;
  font-weight: 600;
  /* font-family: "Montserrat"; */
}
.price-table td.price a {
  background-color: #5336ca;
  color: #FFFFFF;
  padding: 12px 32px;
  margin-top: 16px;
  font-size: 12px;
  font-weight: 600;
  /* font-family: "Montserrat"; */
  text-transform: uppercase;
  display: inline-block;
  border-radius: 64px;
}
.price-table td.price-table-popular {
  /* font-family: "Montserrat"; */
  border-top: 3px solid #5336ca;
  color: #5336ca;
  text-transform: uppercase;
  font-size: 12px;
  padding: 12px 48px;
  font-weight: 700;
}
.price-table .price-blank {
  background-color: #fafafa;
  border: 0 none;
}

.price-table svg {
  width: 90px;
  fill: #5336ca;
}



.recureme-pricing-in {
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}

.recureme-pricing-in .div {
  background-color: #fefaf9;
  width: 100%;
  height: 521px;
  position: relative;
}

.recureme-pricing-in .text-wrapper {
  position: absolute;
  top: 99px;
  /* left: 120px; */
  font-family: "Poppins", Helvetica;
  font-weight: 700;
  color: #1e1e1e;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 29.8px;
  white-space: nowrap;
}

.recureme-pricing-in .group {
  position: absolute;
  width: 100%;
  height: 261px;
  top: 160px;
  /* left: 120px; */
  background-color: #ffede8;
  border-radius: 14px;
}

.recureme-pricing-in .text-wrapper-2 {
  position: absolute;
  top: 23px;
  left: 24px;
  font-family: "Poppins", Helvetica;
  font-weight: 600;
  color: #1e1e1e;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24.8px;
  white-space: nowrap;
}

.recureme-pricing-in .p {
  position: absolute;
  top: 114px;
  left: 24px;
  font-family: "Poppins", Helvetica;
  font-weight: 600;
  color: #1e1e1e;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 29.8px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-3 {
  position: absolute;
  top: 114px;
  left: 1089px;
  font-family: "Poppins", Helvetica;
  font-weight: 700;
  color: #1e1e1e;
  font-size: 24px;
  text-align: right;
  letter-spacing: 0;
  line-height: 29.8px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-4 {
  position: absolute;
  top: 62px;
  left: 24px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #1e1e1e;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-5 {
  position: absolute;
  top: 214px;
  left: 24px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #000000;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-6 {
  position: absolute;
  top: 214px;
  left: 143px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #c8c8c8;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-7 {
  position: absolute;
  top: 214px;
  left: 285px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #c8c8c8;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-8 {
  position: absolute;
  top: 214px;
  left: 429px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #c8c8c8;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-9 {
  position: absolute;
  top: 214px;
  left: 573px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #c8c8c8;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-10 {
  position: absolute;
  top: 214px;
  left: 716px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #c8c8c8;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-11 {
  position: absolute;
  top: 214px;
  left: 860px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #c8c8c8;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-12 {
  position: absolute;
  top: 214px;
  left: 1004px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #c8c8c8;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .text-wrapper-13 {
  position: absolute;
  top: 214px;
  left: 1112px;
  font-family: "Poppins", Helvetica;
  font-weight: 400;
  color: #c8c8c8;
  font-size: 16px;
  text-align: right;
  letter-spacing: 0;
  line-height: 22.1px;
  white-space: nowrap;
}

.recureme-pricing-in .overlap-group {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 171px;
  left: 24px;
}

.recureme-pricing-in .rectangle {
  position: absolute;
  width: 100%;
  height: 10px;
  top: 10px;
  left: 0;
  background-color: #ffffff;
  border-radius: 5px;
}

.recureme-pricing-in .ellipse {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 0;
  left: 0;
  background-color: #ffffff;
  border-radius: 15px;
  border: 4px solid;
  border-color: #ff6036;
}


.footer {
  background: white;
  border-top: solid 2px #f8f9fa;
}
.summary-text {
  margin-left: 15px;
  font-size: 18px;
  color: black;
  font-weight: bold;

}
.price-text {
  font-weight: bold;
  color: black;
}
.current-plan-btn {
  background-color: #FFEDE8;
  color: #FF6036;
  border: none;
  border-radius: 10px;
  padding: 15px 15px;
  font-size: 14px;
  font-weight: bold;
}

.card-custom {
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.manage-btn {
  background-color: #FF6036;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 20px;
}

.summary-header {
  border-bottom: 1px solid #e1e5eb;
  padding: 16px;
}

.summary-body {
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 3px;
}

.summary-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #e1e5eb;
  padding: 16px;
  text-align: right;
}

.credit-section {
  padding-top: 16px;
}

.price-tag {
  /* font-weight: bold; */
  color: black  ;
}

.range-slider-container {
  font-family: Arial, sans-serif;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

.value-display {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  background: #f4f4f4;
  outline: none;
  opacity: 0.7;
  transition: opacity .2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  width: 25px;
  height: 25px;
  background: #ff4500;
  cursor: pointer;
  border-radius: 50%;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #ff4500;
  cursor: pointer;
  border-radius: 50%;
}

.presets {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  margin-top: 10px;
}

.preset-button {
  border: none;
  background-color: transparent;
  cursor: pointer;
  /* padding: 5px 10px; */
  transition: color .3s ease;
}

.preset-button:hover,
.preset-button.active {
  color: #ff4500;
}

.preset-button.custom {
  color: #007bff;
}

.form-control {
padding: 15px;}
/* .slider {position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);width: 500px;height: 60px;padding: 30px;padding-left: 40px;background: #fcfcfc;border-radius: 20px;display: flex;align-items: center;box-shadow: 0px 15px 40px #7E6D5766;}.slider label {font-size: 24px;font-weight: 400;font-family: Open Sans;padding-left: 10px;color: black;}.slider input[type="range"] {width: 420px;height: 2px;background: black;border: none;outline: none;}  */
   
.completed-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background-color: #ff6036;
  color: white;
  border-radius: 50%;
  margin: auto; /* Center the icon horizontally */
  font-size: 14px; /* Adjust the size of the icon as needed */
}

/* Mobile devices (screens less than 768px) */
@media (max-width: 767px) {
  .createCard {
    display: block !important;
  }
}

/* Tablet devices (screens between 768px and 1024px) */
@media (min-width: 768px) and (max-width: 1024px) {
  .createCard {
    display: block !important;
  }
}

.theme-button:disabled{
  background-color: #eead9b !important;
}

.printBtnn:disabled{
  background-color: #ff603696;
  color: white !important;
  border: none;
}

.printBtnn:focus{
  background-color: #f36037 !important;
  color: white !important;
  border: none;
}
.p-datatable-table thead tr th{
  background-color: white !important;
  /* border-bottom: #eaeaea solid 1px; */
}
.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover ,.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled){
  background-color: #FDF5F2 !important;
  color:#FF6036 !important
}
.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {
  color: #f3633c !important;
}
.p-column-title{
  font-size: 16px !important;
  font-family: 'Poppins' !important;
}
.p-datatable .p-datatable-tbody > tr > td{
  border-top: #eaeaea solid 1px;
  margin: 5px;
  font-size: 14px;
  font-family: 'Poppins' !important;
  font-weight: 400 !important;
}
.activity .theme-outline-btn{
  min-width: 150px;
  font-size: 12px !important;
  padding: 5px !important;
  font-weight: normal !important;
}
.textGry{
  color:#ADADAD !important;
font-weight: 400 !important;
}

.p-paginator{
  background-color: white !important;
  border: none !important;
  margin: 10px;
}

.p-paginator .p-paginator-pages .p-paginator-page.p-highlight{

  background-color: #FDF5F2 !important;
  color:#FF6036 !important
}

.p-highlight{

  background-color: #FDF5F2 !important;
  color:#FF6036 !important
}

.detail-block {
  width: 70%;
  margin: auto;
  border: 1px solid #eaeaea;
  background: #fff;
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */
}

.detail-item {
  border-bottom: 1px solid #eaeaea;
  padding: 8px 0; /* Adjust padding to align vertically */
  display: flex; /* Use flexbox for alignment */
  justify-content: start; /* Align to the start of the flex container */
  align-items: center; /* Center align vertically */
}

.detail-item > .label {
  width: 45%; /* Adjust label width as needed */
  text-align: start; /* Right align the label text */
  margin-right: 10px; /* Spacing between label and text */
  font-weight: normal;
}

.detail-item > .text {
  text-align: left; /* Left align the text */
  width: 65%; /* Adjust text width as needed */
}

/* Remove the bottom border for the last item */
.detail-item:last-child {
  border-bottom: none;
}
.datatable-row {
  cursor: pointer;
}

.p-component-overlay{
  background-color: transparent !important;
}
.custom-checkbox-align .checkbox input[type="checkbox"] {
  /* Adjust alignment and spacing as necessary */
  vertical-align: middle;
}

.custom-checkbox-align .checkbox label {
  margin-bottom: 0; /* Ensures label is aligned without extra space below */
  vertical-align: middle;
}









.switches-container {
  width: 16rem;
  position: relative;
  display: flex;
  padding: 0;
  position: relative;
  background: var(--switches-bg-color);
  line-height: 3rem;
  border-radius: 3rem;
  margin-left: auto;
  margin-right: auto;
}

/* input (radio) for toggling. hidden - use labels for clicking on */
.switches-container input {
  visibility: hidden;
  position: absolute;
  top: 0;
}

/* labels for the input (radio) boxes - something to click on */
.switches-container label {
  width: 50%;
  padding: 0;
  margin: 0;
  text-align: center;
  cursor: pointer;
  color: var(--switches-label-color);
  font-weight: bold;
}

/* switch highlighters wrapper (sliding left / right) 
  - need wrapper to enable the even margins around the highlight box
*/
:root {
  --switches-bg-color: #ff6036;
  --switches-label-color: white ;
  --switch-bg-color: white;
  --switch-text-color:#ff6036 ;
}
.switch-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  padding: 0.15rem;
  z-index: 3;
  transition: transform .5s cubic-bezier(.77, 0, .175, 1);
  /* transition: transform 1s; */
}

/* switch box highlighter */
.switchee {
  border-radius: 3rem;
  background: var(--switch-bg-color);
  height: 100%;
}

/* switch box labels
  - default setup
  - toggle afterwards based on radio:checked status 
*/
.switchee div {
  width: 100%;
  text-align: center;
  opacity: 0;
  display: block;
  color: var(--switch-text-color) ;
  transition: opacity .2s cubic-bezier(.77, 0, .175, 1) .125s;
  will-change: opacity;
  position: absolute;
  font-weight: bold;
  top: 0;
  left: 0;
}

/* slide the switch box from right to left */
.switches-container input:nth-of-type(1):checked~.switch-wrapper {
  transform: translateX(0%);
}

/* slide the switch box from left to right */
.switches-container input:nth-of-type(2):checked~.switch-wrapper {
  transform: translateX(100%);
}

/* toggle the switch box labels - first checkbox:checked - show first switch div */
.switches-container input:nth-of-type(1):checked~.switch-wrapper .switchee div:nth-of-type(1) {
  opacity: 1;
}

/* toggle the switch box labels - second checkbox:checked - show second switch div */
.switches-container input:nth-of-type(2):checked~.switch-wrapper .switchee div:nth-of-type(2) {
  opacity: 1;
}
.template .nav-link{
  padding:5px 5px !important
}
.limitedmodel .btn-close{
  top: 15px !important;
  right: 13px !important
}
@media (max-width: 991px) {
  .hide-on-mobile {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/layout.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mDAAmD;EACnD,UAAU;AACZ;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mDAAmD;EACnD,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB;uBACqB;EACrB,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;AACA;;;EAGE,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;;;EAGE,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA,cAAc;AACd;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,iDAAiD;EACjD,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,oCAAoC;AACtC;AACA;EACE,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA,cAAc;AACd;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA,cAAc;AACd;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;;;GAGG;AACH,iBAAiB;;AAEjB;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,OAAO;EACP,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iDAAiD;EACjD,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;;EAEE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE;IACE,eAAe,EAAE,kCAAkC;EACrD;AACF;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;GAEG;AACH,iCAAiC;AACjC;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,iGAAiG;AACjG;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,qBAAqB;EACvC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB,EAAE,yBAAyB;EACjD,cAAc,EAAE,mBAAmB;AACrC;AACA;EACE,8DAA8D;EAC9D,8CAA8C;EAC9C,sBAAsB,EAAE,yBAAyB;EACjD,cAAc,EAAE,mBAAmB;EACnC,8CAA8C;AAChD;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,uBAAuB;AACzB;AACA;EACE,cAAc,EAAE,mBAAmB;EACnC,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;AACF;;;AAGA;EACE,cAAc,EAAE,mBAAmB;EACnC,uBAAuB;AACzB;AACA;EACE,cAAc,EAAE,mBAAmB;EACnC,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;AACF;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa,EAAE,yBAAyB;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa,EAAE,+BAA+B;EAC9C,mBAAmB,EAAE,uBAAuB;EAC5C,uBAAuB,EAAE,yBAAyB;EAClD,WAAW,EAAE,6CAA6C;EAC1D,YAAY,EAAE,8CAA8C;EAC5D,kBAAkB;EAClB,YAAY;EACZ,kBAAkB,EAAE,6BAA6B;AACnD;AACA;EACE,yBAAyB;EACzB,aAAa,EAAE,+BAA+B;EAC9C,mBAAmB,EAAE,uBAAuB;EAC5C,uBAAuB,EAAE,yBAAyB;EAClD,WAAW,EAAE,6CAA6C;EAC1D,YAAY,EAAE,8CAA8C;EAC5D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB,EAAE,6BAA6B;AACnD;AACA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,WAAW;EACX,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,wBAAwB;IACxB,sBAAsB;;AAE1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;GACd,oCAAoC;EACrC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EAEb,0BAA0B;EAE1B;;gDAE8C;EAC9C,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;AACF;;CAEC;EAEC,0BAA0B;EAE1B,0EAA0E;EAElE,yBAAyB;AACnC;CACC;EACC,cAAc;EACd,4CAA4C;EAC5C,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;AAC5E;;CAEC;EACC,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,0EAA0E;AAC5E;;AAEA;EACE,aAAa;AACf;;;;;;;;;;AAUA;EACE,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,yCAAyC;EACzC,cAAc,CAAC,mBAAmB,EAAE,qBAAqB;EACzD,mBAAmB;EACnB,aAAa;IACX,mBAAmB;AACvB;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,gEAAgE;EAChE,0BAA0B;AAC5B;AACA;AACA;EACE,UAAU;AACZ;AACA;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,yDAA8C;EAC9C,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;;EAEjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,sDAAsD;EAC/E,kBAAkB,EAAE,8DAA8D;EAClF,kBAAkB;AACpB;;AAEA;EACE,SAAS,EAAE,2BAA2B;EACtC,cAAc,EAAE,+BAA+B;AACjD;;AAEA;EACE,cAAc,EAAE,0BAA0B;EAC1C,oBAAoB;AACtB;;AAEA;EACE,uBAAuB,EAAE,oCAAoC;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;;;;AAKA;EACE,WAAW;EACX,+BAA+B;EAC/B,cAAc;EACd,yBAAyB;IACvB,oBAAoB,EAAE,+BAA+B;AACzD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;GACf,YAAY;EACb,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;;AAEjC;AACA;EACE,UAAU;AACZ;;;AAGA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;GAKG;AACH;;GAEG;AACH;EACE,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA,uBAAuB;AACvB;;GAEG;AACH;EACE,iDAAiD;EACjD,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;AACtB;AACA,GAAG;;AAEH;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;;;AAIA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;;AAEnB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;AACA,aAAa,CAAC;AACd,2cAA2c;;AAE3c;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY,EAAE,iCAAiC;EAC/C,eAAe,EAAE,0CAA0C;AAC7D;;AAEA,6CAA6C;AAC7C;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B,2BAA2B;AAC3B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,oCAAoC;EACpC;AACF;;AAEA;;EAEE,oCAAoC;EACpC;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,cAAc,EAAE,uCAAuC;EACvD,aAAa,EAAE,8BAA8B;EAC7C,sBAAsB,EAAE,6CAA6C;EACrE,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,UAAU,EAAE,iCAAiC;EAC7C,iBAAiB,EAAE,+BAA+B;EAClD,kBAAkB,EAAE,mCAAmC;EACvD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,EAAE,wBAAwB;EAC1C,UAAU,EAAE,gCAAgC;AAC9C;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB,EAAE,uDAAuD;EACzE,sBAAsB;AACxB;;;;;;;;;;AAUA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;AACR;;AAEA,+DAA+D;AAC/D;EACE,UAAU;EACV,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;CAEC;AACD;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,uDAAuD;EACvD,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;AACd;;AAEA;;;CAGC;AACD;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gCAAgC;EAChC,2DAA2D;EAC3D,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,MAAM;EACN,OAAO;AACT;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,2BAA2B;AAC7B;;AAEA,kFAAkF;AAClF;EACE,UAAU;AACZ;;AAEA,oFAAoF;AACpF;EACE,UAAU;AACZ;AACA;EACE;AACF;AACA;EACE,oBAAoB;EACpB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["a {\r\n  text-decoration: none;\r\n}\r\n.layout-main {\r\n  /* display: flex; */\r\n  width: 100vw;\r\n  height: 100vh;\r\n  position: relative;\r\n  overflow: hidden;\r\n  background-color: #fbfcfd;\r\n}\r\n.layout-main .sider {\r\n  display: flex;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 265px;\r\n  height: 100vh;\r\n  background: #fff;\r\n  box-shadow: rgb(113 122 131 / 11%) 0px 7px 30px 0px;\r\n  z-index: 9;\r\n}\r\n.layout-main .content-part {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  background: #fbfcfd;\r\n  flex-direction: column;\r\n}\r\n.layout-main .content-part .header-part {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 80px;\r\n  background: white;\r\n  box-shadow: rgb(113 122 131 / 11%) 0px 7px 30px 0px;\r\n  padding-left: 265px;\r\n  position: relative;\r\n  top: 0;\r\n}\r\n.layout-main .content-part .content {\r\n  width: 100%;\r\n  padding-left: 265px;\r\n  max-height: 100vh;\r\n  /* margin-top: 80px; */\r\n  /* margin-bottom:80px; */\r\n  overflow-y: scroll;\r\n}\r\n\r\n.main-content-part {\r\n  padding: 30px 30px 30px 30px;\r\n  /* height: 80vh; */\r\n  /* max-height:100vh;\r\n    overflow: scroll; */\r\n  margin-bottom: 5rem !important;\r\n}\r\n.main-content-part.excersiceList {\r\n  padding: 35px 0;\r\n}\r\n.main-content-part.excersiceList .exercise-tab-part {\r\n  padding: 0 70px 0 35px;\r\n}\r\n.button-part {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n.theme-outline-btn {\r\n  font-size: 16px;\r\n  border-radius: 28px;\r\n  min-width: 300px;\r\n  padding: 14px;\r\n  border: 1px solid #ff6036;\r\n  background-color: transparent;\r\n  color: #ff6036;\r\n  font-weight: 600;\r\n}\r\n.theme-outline-btn:hover {\r\n  background-color: #ff6036cf !important;\r\n  box-shadow: none;\r\n  border-color: #ff6036;\r\n  color: #fff;\r\n}\r\n.theme-button {\r\n  background-color: #ff6036;\r\n  font-size: 14px;\r\n  border-radius: 28px;\r\n  min-width: 300px;\r\n  padding: 14px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n.theme-button:hover,\r\n.theme-button:focus,\r\n.btn:focus-visible {\r\n  background-color: #ff6036cf !important;\r\n  box-shadow: none;\r\n  border-color: #ff6036;\r\n}\r\n\r\n.secondary-button {\r\n  background-color: #a8a8a8;\r\n  font-size: 16px;\r\n  border-radius: 28px;\r\n  min-width: 300px;\r\n  padding: 14px;\r\n  font-weight: 600;\r\n}\r\n.secondary-button:hover,\r\n.theme-button:focus,\r\n.btn:focus-visible {\r\n  background-color: #a8a8a8 !important;\r\n  box-shadow: none;\r\n  border-color: #a8a8a8;\r\n}\r\n\r\n.theme-button span {\r\n  font-weight: 500;\r\n}\r\n/* modal css */\r\n.modal-content {\r\n  border-radius: 12px;\r\n  border: 1px solid #707070;\r\n  padding: 20px 30px;\r\n}\r\n.btn-close {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 13px;\r\n}\r\n.modal-header {\r\n  text-align: center;\r\n  justify-content: center;\r\n  border-bottom: 1px solid #eaeaea;\r\n  padding: 0;\r\n}\r\n.modal-header .modal-title {\r\n  font-size: 22px;\r\n  font-weight: 500;\r\n  padding-bottom: 24px;\r\n}\r\n.modal-body {\r\n  border: 0;\r\n  padding: 24px 0;\r\n}\r\n.body-content .body-title {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n}\r\ntextarea.form-control {\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  color: #000000;\r\n  padding: 18px;\r\n}\r\ntextarea.form-control:focus {\r\n  box-shadow: none;\r\n  border-color: #eaeaea;\r\n}\r\n.modal-footer {\r\n  border: 0;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n.modal-content .theme-button {\r\n  min-width: 250px;\r\n  padding: 8px;\r\n}\r\n.modal-content .footerLink {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  text-decoration: none;\r\n  color: #1d2432;\r\n}\r\n.file-area {\r\n  width: 100%;\r\n  position: relative;\r\n  border: 1px dashed #1d2432;\r\n  border-radius: 8px;\r\n  height: 150px;\r\n}\r\n.file-area input[type=\"file\"] {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n}\r\n.file-area .file-dummy {\r\n  width: 100%;\r\n  padding: 30px;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  /* border: 2px dashed rgba(255, 255, 255, 0.2); */\r\n  height: 150px;\r\n  text-align: center;\r\n  transition: background 0.3s ease-in-out;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n.file-area .file-dummy .success {\r\n  display: none;\r\n}\r\n.file-area:hover .file-dummy {\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n.file-area input[type=\"file\"]:focus + .file-dummy {\r\n  outline: 2px solid rgba(255, 255, 255, 0.5);\r\n  outline: -webkit-focus-ring-color auto 5px;\r\n}\r\n.file-area input[type=\"file\"]:valid + .file-dummy {\r\n  border-color: rgb(248 212 203 / 23%);\r\n  background-color: rgb(248 212 203 / 23%);\r\n}\r\n.file-area input[type=\"file\"]:valid + .file-dummy .success {\r\n  display: inline-block;\r\n}\r\n.file-area input[type=\"file\"]:valid + .file-dummy .default {\r\n  display: none;\r\n}\r\n\r\n/* progressbar */\r\n\r\n.progressBar .progressText {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.progressBar .progressText p {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  margin-bottom: 6px;\r\n  color: #1d2432;\r\n}\r\n.progressBar .progress {\r\n  height: 10px;\r\n  background-color: #fdf5f2;\r\n  border-radius: 14px;\r\n}\r\n.progressBar .progress .progress-bar {\r\n  background-color: #ff6036;\r\n  border-radius: 14px;\r\n}\r\n\r\n/* searchpart */\r\n.serchPart .searchInput input {\r\n  border-radius: 46px;\r\n  box-shadow: 0px 1px 15px #0000000f;\r\n  padding: 15px 10px 15px 82px;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  border: 0;\r\n  width: 100%;\r\n}\r\n.serchPart .searchInput {\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 70%;\r\n  position: relative;\r\n  /* margin: 0 auto 35px; */\r\n}\r\n.serchPart .searchInput .searchIcon {\r\n  position: absolute;\r\n  left: 30px;\r\n  top: 17px;\r\n}\r\n.serchPart .searchInput .filterIcon {\r\n  position: absolute;\r\n  right: 24px;\r\n  top: 17px;\r\n  cursor: pointer;\r\n}\r\n.serchPart .searchInput input:focus {\r\n  outline: 0;\r\n}\r\n/* note-part */\r\n.note-part {\r\n  background-color: #fdf5f3;\r\n  color: #ff6036;\r\n  padding: 30px;\r\n}\r\n\r\n/* form-data */\r\n.form-data.full-width-data {\r\n  max-width: 90%;\r\n}\r\n.form-data .title {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  text-align: center;\r\n  margin-bottom: 35px;\r\n}\r\n.form-data {\r\n  max-width: 70%;\r\n  margin: auto;\r\n}\r\n.form-data .filed {\r\n  margin-bottom: 15px;\r\n}\r\n.form-data .filed label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  display: block;\r\n  margin-bottom: 8px;\r\n}\r\n.form-data .filed input,\r\n.form-select {\r\n  border: 1px solid #eaeaea;\r\n  border-radius: 8px;\r\n  padding: 15px;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  width: 100%;\r\n}\r\n\r\ninput:focus {\r\n  outline: none;\r\n}\r\n/* .form-select:focus{\r\n  box-shadow: none;\r\n  border: 1px solid #EAEAEA;\r\n} */\r\n/* yes-no-radio */\r\n\r\n.yes-no-radio {\r\n  display: flex;\r\n  gap: 15px;\r\n}\r\n.yes-no-radio input[type=\"radio\"] {\r\n  display: none;\r\n}\r\n.yes-no-radio input[type=\"radio\"]:checked + .box {\r\n  background-color: transparent;\r\n  border: 1px solid #ff6036;\r\n}\r\n.yes-no-radio input[type=\"radio\"]:checked + .box span {\r\n  color: #ff6036;\r\n}\r\n.yes-no-radio .box {\r\n  border: 1px solid #eaeaea;\r\n  padding: 16px 20px;\r\n  border-radius: 8px;\r\n  background-color: #fff;\r\n  transition: all 250ms ease;\r\n  will-change: transition;\r\n  display: inline-block;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  position: relative;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  min-width: 150px;\r\n}\r\n.yes-no-radio .box span {\r\n  transform: translate(0, 60px);\r\n  left: 0;\r\n  right: 0;\r\n  transition: all 300ms ease;\r\n  font-size: 1.5em;\r\n  user-select: none;\r\n  color: #1d2432;\r\n}\r\n.timer-block .yes-no-radio label {\r\n  margin-bottom: 0;\r\n}\r\n.timer-block .yes-no-radio .box {\r\n  min-width: 60px;\r\n  padding: 10px 12px;\r\n}\r\n\r\n.myProfileCard {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 15px;\r\n  align-items: center;\r\n}\r\n\r\n.myProfileCard > h6 {\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  color: black !important;\r\n}\r\n\r\n.light-text {\r\n  color: #adadad;\r\n}\r\n.btn-theme-bg {\r\n  background: #ff623610 0% 0% no-repeat padding-box;\r\n  border-radius: 26px;\r\n  color: #ff6036;\r\n  font: normal normal medium 17px/26px Poppins;\r\n}\r\n.btn-theme-bg > svg > path,\r\n.btn-theme-bg > svg > g > path {\r\n  fill: #ff6036;\r\n}\r\n\r\n.printBtn {\r\n  font-size: 14px;\r\n  border-radius: 1px;\r\n  min-width: 45px;\r\n  padding: 7px;\r\n  border: 1px solid #eaeaea;\r\n  background-color: transparent;\r\n  color: #ff6036;\r\n  font-weight: 500;\r\n}\r\n\r\n.printBtn:hover {\r\n  color: white;\r\n  background-color: #ff6036;\r\n  border-color: #ff6036;\r\n}\r\n\r\n.printBtnn > svg > path {\r\n  fill: white;\r\n}\r\n.printBtnn:hover > svg > path {\r\n  fill: #ff6036;\r\n}\r\n.printBtnn {\r\n  font-size: 14px;\r\n  border:1px solid #eaeaea;\r\n  min-width: 45px;\r\n  padding: 7px;\r\n  border-color: #ff6036;\r\n  background-color: #ff6036;\r\n  font-weight: 500;\r\n  color: white;\r\n}\r\n\r\n.printBtnn:hover {\r\n  color: #ff6036;\r\n  background-color: transparent;\r\n  border: 1px solid #eaeaea;\r\n}\r\n\r\n.highlightOption {\r\n  background: #ff6036 !important;\r\n  color: #fff;\r\n}\r\n.option {\r\n  font-size: 14px !important;\r\n}\r\n.notFound {\r\n  font-size: 14px !important;\r\n}\r\n.option:hover {\r\n  background: #ff6036 !important;\r\n  color: #fff;\r\n}\r\n.icon_down_dir:before {\r\n  content: \"\" !important;\r\n}\r\n.multiSelectContainer input {\r\n  font-size: 14px !important;\r\n}\r\n.chip {\r\n  align-items: center;\r\n  background: #ff6036 !important;\r\n  border-radius: 11px;\r\n  color: #fff;\r\n  display: inline-flex;\r\n  font-size: 13px;\r\n  line-height: 19px;\r\n  margin-bottom: 5px;\r\n  margin-right: 5px;\r\n  padding: 4px 10px;\r\n}\r\n.printBtn:hover > svg > path,\r\n.printBtn:hover > a > svg > path {\r\n  fill: white;\r\n}\r\n\r\n/* Example CSS styles */\r\n.content-container {\r\n  max-width: 40%; /* Adjust as needed */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .content-container {\r\n    max-width: 100%; /* Full width on smaller screens */\r\n  }\r\n}\r\n\r\n.filed > label {\r\n  font-size: 14px;\r\n}\r\n.checkbox > span {\r\n  font-size: 14px;\r\n}\r\n/* .searchWrapper {\r\n   border: none !important; \r\n} */\r\n/* Base style for the checkmark */\r\n.radio-container .checkmark {\r\n  display: inline-block;\r\n  height: 25px;\r\n  width: 25px;\r\n  background-color: #f2f2f2;\r\n  border-radius: 50%;\r\n  position: relative;\r\n  border: 1px solid #d9d9d9;\r\n}\r\n\r\n/* Hide the checkmark by default */\r\n.radio-container .checkmark:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  display: none;\r\n}\r\n\r\n/* When the associated radio input is checked, change the checkmark background and border color */\r\n.radio-container input[type=\"radio\"]:checked + .checkmark {\r\n  background-color: #ff6036;\r\n  border-color: #ff6036;\r\n}\r\n\r\n/* Style the checkmark indicator */\r\n.radio-container input[type=\"radio\"]:checked + .checkmark:after {\r\n  display: block;\r\n  left: 9px;\r\n  top: 5px;\r\n  width: 5px;\r\n  height: 10px;\r\n  border: solid white;\r\n  border-width: 0 3px 3px 0;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.radio-container input[type=\"radio\"] {\r\n  display: none;\r\n}\r\n\r\n.no-block {\r\n  display: flex;\r\n  min-width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  background-color: #adadad;\r\n  color: #fff;\r\n  font-size: 15px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0;\r\n}\r\n\r\n.info-section {\r\n  display: flex;\r\n  /* align-items: center; */\r\n  /* margin-bottom: 10px; */\r\n  font-size: 14px;\r\n}\r\n\r\n.label {\r\n  min-width: 100px; /* Adjust as needed */\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n}\r\n\r\n.data {\r\n  flex-grow: 1;\r\n  font-size: 14px;\r\n}\r\n\r\n.cardFromPrice {\r\n  background-color: white;\r\n  color: black;\r\n  border-radius: 14px;\r\n  border: none;\r\n}\r\n.cardFromPrice:hover {\r\n  background-color: #ff6036;\r\n  color: white !important;\r\n  cursor: pointer;\r\n}\r\n.cardFromPriceSelected {\r\n  background-color: #ff6036;\r\n  color: white !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.cardFromPriceSelected  .select-btn {\r\n  background-color: #fff; /* New background color */\r\n  color: #ff6036; /* New text color */\r\n}\r\n.cardFromPrice:hover .select-btn {\r\n  /* Styles to apply to .select-btn on hover of .cardFromPrice */\r\n  /* Example: change background and text color */\r\n  background-color: #fff; /* New background color */\r\n  color: #ff6036; /* New text color */\r\n  /* Add other properties and values as needed */\r\n}\r\n\r\n.cardFromPrice:hover .successIcon  {\r\n  color: #ff6036; /* New text color */\r\n  background-color: white;\r\n}\r\n.cardFromPrice:hover .failureIcon  {\r\n  color: #000000; /* New text color */\r\n  background-color: white;\r\n}\r\n.cardFromPrice:hover .price {\r\n  color: white;\r\n}\r\n\r\n.cardFromPrice:hover .priceSub {\r\n  color: white;\r\n}\r\n\r\n.cardFromPrice:hover .priceData{\r\n  color:white\r\n}\r\n\r\n\r\n.cardFromPriceSelected .successIcon  {\r\n  color: #ff6036; /* New text color */\r\n  background-color: white;\r\n}\r\n.cardFromPriceSelected .failureIcon  {\r\n  color: #000000; /* New text color */\r\n  background-color: white;\r\n}\r\n.cardFromPriceSelected .price {\r\n  color: white;\r\n}\r\n\r\n.cardFromPriceSelected .priceSub {\r\n  color: white;\r\n}\r\n\r\n.cardFromPriceSelected .priceData{\r\n  color:white\r\n}\r\n.iconTd{\r\n  display: inline-block;\r\n  align-items: center;\r\n}\r\n.priceData{\r\n  color: gray;\r\n}\r\n.priceTitle {\r\n  font-weight: 400;\r\n  font-size: 20px;\r\n}\r\n.price {\r\n  font-size: 24px;\r\n  color: #000000;\r\n  font-weight: bold;\r\n}\r\n\r\n.priceSub {\r\n  font-size: 20px;\r\n  color: #000000;\r\n  font-weight: 400;\r\n}\r\n.check-icon {\r\n  color: #28a745;\r\n  margin-right: 5px;\r\n}\r\n\r\n.features {\r\n  margin: 15px 0;\r\n}\r\n\r\n.features li {\r\n  margin: 10px 0;\r\n  font-size: 12px;\r\n  display: flex; /* Align icon with text */\r\n}\r\n\r\n.select-btn {\r\n  background-color: #ff6036;\r\n  color: white;\r\n  border-radius: 10px;\r\n  border: none;\r\n  padding: 10px 50px;\r\n  font-weight: 500;\r\n}\r\n\r\n.select-btn:hover {\r\n  background-color: #e55a2f;\r\n  color: white;\r\n}\r\n\r\n.successIcon {\r\n  background-color: #d5ffe6;\r\n  display: flex; /* Use flexbox to align items */\r\n  align-items: center; /* Vertical alignment */\r\n  justify-content: center; /* Horizontal alignment */\r\n  width: 20px; /* Set a fixed width for the icon container */\r\n  height: 20px; /* Set a fixed height for the icon container */\r\n  border-radius: 50%;\r\n  padding: 5px;\r\n  margin-right: 10px; /* Right margin for spacing */\r\n}\r\n.failureIcon {\r\n  background-color: #efefef;\r\n  display: flex; /* Use flexbox to align items */\r\n  align-items: center; /* Vertical alignment */\r\n  justify-content: center; /* Horizontal alignment */\r\n  width: 20px; /* Set a fixed width for the icon container */\r\n  height: 20px; /* Set a fixed height for the icon container */\r\n  padding: 5px;\r\n  border-radius: 50%;\r\n  margin-right: 10px; /* Right margin for spacing */\r\n}\r\n/* .carousel-indicators  {\r\n  box-sizing: content-box;\r\n  flex: 0 1 auto;\r\n  width: 15px;\r\n  height: 15px;\r\n  padding: 0;\r\n  margin-right: 3px;\r\n  margin-left: 3px;\r\n  text-indent: -999px;\r\n  cursor: pointer;\r\n  background-color: #ff6036;\r\n  background-clip: padding-box;\r\n  border: 0;\r\n  border-top: 10px solid transparent;\r\n  border-bottom: 10px solid transparent;\r\n  opacity: .5;\r\n  transition: opacity .6s ease;\r\n} */\r\n\r\n.carousel-indicators .active {\r\n  box-sizing: content-box;\r\n  flex: 0 1 auto;\r\n  width: 10px;\r\n  height: 10px;\r\n  padding: 0;\r\n  margin-right: 3px;\r\n  margin-left: 3px;\r\n  text-indent: -999px;\r\n  cursor: pointer;\r\n  background-color: #ff6036;\r\n  background-clip: padding-box;\r\n  border-radius: 50%;\r\n  border-top: 10px solid transparent;\r\n  border-bottom: 10px solid transparent;\r\n  transition: opacity .6s ease;\r\n}\r\n\r\n.carousel-indicators :not(.active) {\r\n  box-sizing: content-box;\r\n  flex: 0 1 auto;\r\n  width: 10px;\r\n  height: 10px;\r\n  padding: 0;\r\n  margin-right: 3px;\r\n  margin-left: 3px;\r\n  text-indent: -999px;\r\n  cursor: pointer;\r\n  background-color: #ff62367c;\r\n  background-clip: padding-box;\r\n  border-radius: 50%;\r\n  border-top: 10px solid transparent;\r\n  border-bottom: 10px solid transparent;\r\n  opacity: .5;\r\n  transition: opacity .6s ease;\r\n}\r\n\r\n.carousel-indicators {\r\n  position: absolute;\r\n  left: 0px;\r\n  right: auto;\r\n  top:20rem;\r\n  bottom: 0px;\r\n  z-index: 2;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 0;\r\n  margin-right: 0%;\r\n  margin-bottom: 0rem;\r\n  margin-left: 0%;\r\n}\r\n\r\n.faq > label > p {\r\n    margin-top: auto;\r\n    margin-bottom: 0rem;\r\n    display: block;\r\n    margin-block-start: 1.5em;\r\n    margin-block-end: 1em;\r\n    margin-inline-start: 0px;\r\n    margin-inline-end: 0px;\r\n\r\n}\r\n\r\n.faq-heading {\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n   -webkit-transition: text-indent 0.2s;\r\n  text-indent: 20px;\r\n  color: #000000;\r\n  font-weight: 500;\r\n}\r\n\r\n.faq-text {\r\n  font-weight: 400;\r\n  color: #919191;\r\n  width:95%;\r\n  padding-left:20px;\r\n  margin-bottom:30px;\r\n}\r\n\r\n.faq {\r\n  width: 1000px;\r\n  margin: 0 auto;\r\n  /* background: white; */\r\n  border-radius: 4px;\r\n  position: relative;\r\n  /* border: 1px solid #E1E1E1; */\r\n}\r\n.faq label {\r\n  display: block;\r\n  position: relative;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  height: 56px;\r\n  padding-top:1px;\r\n  margin-top: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n  background-color:white;\r\n  border-radius: 14px;\r\n  color: #000000;\r\n  font-weight: bolder;\r\n  /* border-bottom: 1px solid #E1E1E1; */\r\n}\r\n\r\n.faq input[type=\"checkbox\"] {\r\n  display: none;\r\n}\r\n\r\n.faq .faq-arrow {\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #ff6036;\r\n  border-radius: 50%;\r\n  padding: 15px;\r\n  transition: -webkit-transform 0.8s;\r\n  transition: transform 0.8s;\r\n  transition: transform 0.8s, -webkit-transform 0.8s;\r\n  /* -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  border-top: 2px solid rgba(0, 0, 0, 0.33);\r\n  border-right: 2px solid rgba(0, 0, 0, 0.33); */\r\n  float: right;\r\n  position: relative;\r\n  top: -40px;\r\n  right: 27px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n}\r\n.faq .faq-arrow > i {\r\n  color:white\r\n}\r\n\r\n .faq input[type=\"checkbox\"]:checked + label > .faq-arrow {\r\n  transition: -webkit-transform 0.8s;\r\n  transition: transform 0.8s;\r\n  transition: transform 0.8s, -webkit-transform 0.8s;\r\n  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  -webkit-transform: rotate(135deg);\r\n          transform: rotate(135deg);\r\n}\r\n .faq input[type=\"checkbox\"]:checked + label {\r\n  display: block;\r\n  background: rgba(255,255,255,255) !important;\r\n  color: #4f7351;\r\n  height: fit-content;\r\n  transition: height 0.8s;\r\n  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n .faq input[type='checkbox']:not(:checked) + label {\r\n  display: block;\r\n  transition: height 0.8s;\r\n  height: 60px;\r\n  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n:root{\r\n  --white:#fff;\r\n  --smoke-white:#f1f3f5;\r\n  --blue:#FFEDE8;\r\n}\r\n\r\n.selector{\r\n  position:relative;\r\n  width:max-content;\r\n  background-color:white;\r\n  height:50px;\r\n  display:flex;\r\n  padding-left: 3rem;\r\n  padding-right: 3rem;\r\n  justify-content:center;\r\n  align-items:center;\r\n  border-radius:14px;\r\n  /* box-shadow:0 0 16px rgba(0,0,0,.2); */\r\n}\r\n.selector-item{\r\n  position:relative;\r\n  flex-basis:calc(70% / 3);\r\n  height:100%;\r\n  display:flex;\r\n  justify-content:center;\r\n  align-items:center;\r\n}\r\n.selector-item_radio{\r\n  appearance:none;\r\n  display:none;\r\n}\r\n.selector-item_label{\r\n  position:relative;\r\n  height:80%;\r\n  width:fit-content;\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  text-align:center;\r\n  border-radius:14px;\r\n  font-family: 'Poppins', sans-serif;\r\n  font-weight:700;\r\n  font-size: 14px;\r\n  transition-duration:.5s;\r\n  transition-property:transform, box-shadow;\r\n  transform:none;white-space: nowrap; display: inline-block;\r\n  align-items: center;\r\n  display: flex;\r\n    align-items: center;\r\n}\r\n.selector-item_radio:checked + .selector-item_label{\r\n  background-color:var(--blue);\r\n  color:black;\r\n  /* box-shadow:0 0 4px rgba(0,0,0,.5),0 2px 4px rgba(0,0,0,.5); */\r\n  transform:translateY(-2px);\r\n}\r\n@media (max-width:480px) {\r\n.selector{\r\n  width: 90%;\r\n}\r\n}\r\n\r\n\r\n\r\n.advanced-needs-section {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #ff6036;\r\n  background-image: url('../images/pattern.png');\r\n  color: white;\r\n  padding-right: 20px;\r\n  padding-left: 20px;\r\n  padding-top: 20px;\r\n\r\n  border-radius: 14px;\r\n}\r\n\r\n.advanced-needs-section-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center; /* Centers content vertically within the content div */\r\n  align-items: start; /* Aligns content to the start (left) within the content div */\r\n  padding-left: 2rem;\r\n}\r\n\r\n.advanced-needs-section-content h2 {\r\n  margin: 0; /* Removes default margin */\r\n  font-size: 2em; /* Adjust font size as needed */\r\n}\r\n\r\n.advanced-needs-section .advanced-needs-section-content h2 {\r\n  font-size: 2em; /* Adjust size as needed */\r\n  margin-bottom: 0.5em;\r\n}\r\n\r\n.advanced-needs-section .advanced-needs-section-content button {\r\n  background-color: black; /* Adjust button styling as needed */\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.advanced-needs-section .image-container img {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n/* Responsive styling */\r\n@media (max-width: 768px) {\r\n  .advanced-needs-section {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  .advanced-needs-section .image-container {\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n.price-table {\r\n  width: 100%;\r\n  /* border-collapse: collapse; */\r\n  border: 0 none;\r\n  border-collapse: separate;\r\n    border-spacing: 10px; /* Adjust the value as needed */\r\n}\r\n.price-table tr:not(:last-child) {\r\n  border-bottom: 1px dashed rgba(0, 0, 0, 0.03);\r\n}\r\n.price-table tr td {\r\n  /* border-left: 1px solid rgba(0, 0, 0, 0.05); */\r\n  padding: 13px 30px;\r\n  font-size: 14px;\r\n  border: white 4px;\r\n}\r\n\r\n\r\n.price-table tr.price-table-head td  {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  padding: 0px 0px;\r\n   margin: 3rem;\r\n  /* font-family: \"Montserrat\"; */\r\n  background-color: #FFEDE8;\r\n  /* text-transform: uppercase; */\r\n\r\n}\r\n.price-table tr.price-table-head td:not(:first-child) {\r\n  width: 18%;\r\n}\r\n\r\n\r\n.price-table tr td:first-child {\r\n  border-left: 0 none;\r\n}\r\n.price-table tr td{\r\n  text-align: center;\r\n}\r\n/* .price-table tr:nth-child(even) {\r\n  background-color: #FFFFFF;\r\n}\r\n.price-table tr:hover {\r\n  background-color: #EEEEEE;\r\n} */\r\n/* .price-table .fa-check {\r\n  color: #397752;\r\n} */\r\n.price-table .fa-times {\r\n  color: #D8D6E3;\r\n}\r\n\r\n.price-table tr td:nth-child(1) {\r\n  /* background-color: rgba(216, 214, 227, 0.15); */\r\n  text-align: left;\r\n}\r\n/* Highlighted column */\r\n/* .price-table tr:nth-child(2n) td:nth-child(3) {\r\n  background-color: rgba(216, 214, 227, 0.25);\r\n} */\r\n.price-table tr td:nth-child(3) {\r\n  /* background-color: rgba(216, 214, 227, 0.15); */\r\n  padding: 8px 48px;\r\n}\r\n.price-table tr td:nth-child(3) .fa-check,\r\n.price-table tr:nth-child(2n) td:nth-child(3) .fa-check {\r\n  /* color: #ffffff; */\r\n}\r\n/**/\r\n\r\n.price-table > td {\r\n  margin: 3rem;\r\n}\r\n.price-table tr.price-table-head td>span {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  width: 100%;\r\n  display: block;\r\n  /* font-family: \"Montserrat\"; */\r\n  background-color: #FFEDE8;\r\n  /* text-transform: uppercase; */\r\n}\r\n.price-table tr.price-table-head {\r\n  /* background-color: #5336ca; */\r\n  color: black;\r\n}\r\n.price-table td.price {\r\n  color: #f43f54;\r\n  padding: 16px 24px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  /* font-family: \"Montserrat\"; */\r\n}\r\n.price-table td.price a {\r\n  background-color: #5336ca;\r\n  color: #FFFFFF;\r\n  padding: 12px 32px;\r\n  margin-top: 16px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  /* font-family: \"Montserrat\"; */\r\n  text-transform: uppercase;\r\n  display: inline-block;\r\n  border-radius: 64px;\r\n}\r\n.price-table td.price-table-popular {\r\n  /* font-family: \"Montserrat\"; */\r\n  border-top: 3px solid #5336ca;\r\n  color: #5336ca;\r\n  text-transform: uppercase;\r\n  font-size: 12px;\r\n  padding: 12px 48px;\r\n  font-weight: 700;\r\n}\r\n.price-table .price-blank {\r\n  background-color: #fafafa;\r\n  border: 0 none;\r\n}\r\n\r\n.price-table svg {\r\n  width: 90px;\r\n  fill: #5336ca;\r\n}\r\n\r\n\r\n\r\n.recureme-pricing-in {\r\n  background-color: #ffffff;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.recureme-pricing-in .div {\r\n  background-color: #fefaf9;\r\n  width: 100%;\r\n  height: 521px;\r\n  position: relative;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper {\r\n  position: absolute;\r\n  top: 99px;\r\n  /* left: 120px; */\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 700;\r\n  color: #1e1e1e;\r\n  font-size: 24px;\r\n  letter-spacing: 0;\r\n  line-height: 29.8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .group {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 261px;\r\n  top: 160px;\r\n  /* left: 120px; */\r\n  background-color: #ffede8;\r\n  border-radius: 14px;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-2 {\r\n  position: absolute;\r\n  top: 23px;\r\n  left: 24px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 600;\r\n  color: #1e1e1e;\r\n  font-size: 18px;\r\n  letter-spacing: 0;\r\n  line-height: 24.8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .p {\r\n  position: absolute;\r\n  top: 114px;\r\n  left: 24px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 600;\r\n  color: #1e1e1e;\r\n  font-size: 24px;\r\n  letter-spacing: 0;\r\n  line-height: 29.8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-3 {\r\n  position: absolute;\r\n  top: 114px;\r\n  left: 1089px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 700;\r\n  color: #1e1e1e;\r\n  font-size: 24px;\r\n  text-align: right;\r\n  letter-spacing: 0;\r\n  line-height: 29.8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-4 {\r\n  position: absolute;\r\n  top: 62px;\r\n  left: 24px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #1e1e1e;\r\n  font-size: 16px;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-5 {\r\n  position: absolute;\r\n  top: 214px;\r\n  left: 24px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #000000;\r\n  font-size: 16px;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-6 {\r\n  position: absolute;\r\n  top: 214px;\r\n  left: 143px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #c8c8c8;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-7 {\r\n  position: absolute;\r\n  top: 214px;\r\n  left: 285px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #c8c8c8;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-8 {\r\n  position: absolute;\r\n  top: 214px;\r\n  left: 429px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #c8c8c8;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-9 {\r\n  position: absolute;\r\n  top: 214px;\r\n  left: 573px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #c8c8c8;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-10 {\r\n  position: absolute;\r\n  top: 214px;\r\n  left: 716px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #c8c8c8;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-11 {\r\n  position: absolute;\r\n  top: 214px;\r\n  left: 860px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #c8c8c8;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-12 {\r\n  position: absolute;\r\n  top: 214px;\r\n  left: 1004px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #c8c8c8;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .text-wrapper-13 {\r\n  position: absolute;\r\n  top: 214px;\r\n  left: 1112px;\r\n  font-family: \"Poppins\", Helvetica;\r\n  font-weight: 400;\r\n  color: #c8c8c8;\r\n  font-size: 16px;\r\n  text-align: right;\r\n  letter-spacing: 0;\r\n  line-height: 22.1px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.recureme-pricing-in .overlap-group {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 30px;\r\n  top: 171px;\r\n  left: 24px;\r\n}\r\n\r\n.recureme-pricing-in .rectangle {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 10px;\r\n  top: 10px;\r\n  left: 0;\r\n  background-color: #ffffff;\r\n  border-radius: 5px;\r\n}\r\n\r\n.recureme-pricing-in .ellipse {\r\n  position: absolute;\r\n  width: 30px;\r\n  height: 30px;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: #ffffff;\r\n  border-radius: 15px;\r\n  border: 4px solid;\r\n  border-color: #ff6036;\r\n}\r\n\r\n\r\n.footer {\r\n  background: white;\r\n  border-top: solid 2px #f8f9fa;\r\n}\r\n.summary-text {\r\n  margin-left: 15px;\r\n  font-size: 18px;\r\n  color: black;\r\n  font-weight: bold;\r\n\r\n}\r\n.price-text {\r\n  font-weight: bold;\r\n  color: black;\r\n}\r\n.current-plan-btn {\r\n  background-color: #FFEDE8;\r\n  color: #FF6036;\r\n  border: none;\r\n  border-radius: 10px;\r\n  padding: 15px 15px;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n}\r\n\r\n.card-custom {\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\r\n}\r\n\r\n.manage-btn {\r\n  background-color: #FF6036;\r\n  border: none;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  border-radius: 20px;\r\n}\r\n\r\n.summary-header {\r\n  border-bottom: 1px solid #e1e5eb;\r\n  padding: 16px;\r\n}\r\n\r\n.summary-body {\r\n  padding: 16px;\r\n  background-color: #f8f9fa;\r\n  border-radius: 3px;\r\n}\r\n\r\n.summary-footer {\r\n  background-color: #f8f9fa;\r\n  border-top: 1px solid #e1e5eb;\r\n  padding: 16px;\r\n  text-align: right;\r\n}\r\n\r\n.credit-section {\r\n  padding-top: 16px;\r\n}\r\n\r\n.price-tag {\r\n  /* font-weight: bold; */\r\n  color: black  ;\r\n}\r\n\r\n.range-slider-container {\r\n  font-family: Arial, sans-serif;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.value-display {\r\n  font-size: 18px;\r\n  color: #333;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.slider {\r\n  -webkit-appearance: none;\r\n  width: 100%;\r\n  height: 15px;\r\n  background: #f4f4f4;\r\n  outline: none;\r\n  opacity: 0.7;\r\n  transition: opacity .2s;\r\n}\r\n\r\n.slider:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.slider::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 25px;\r\n  height: 25px;\r\n  background: #ff4500;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n}\r\n\r\n.slider::-moz-range-thumb {\r\n  width: 25px;\r\n  height: 25px;\r\n  background: #ff4500;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n}\r\n\r\n.presets {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 0 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.preset-button {\r\n  border: none;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n  /* padding: 5px 10px; */\r\n  transition: color .3s ease;\r\n}\r\n\r\n.preset-button:hover,\r\n.preset-button.active {\r\n  color: #ff4500;\r\n}\r\n\r\n.preset-button.custom {\r\n  color: #007bff;\r\n}\r\n\r\n.form-control {\r\npadding: 15px;}\r\n/* .slider {position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);width: 500px;height: 60px;padding: 30px;padding-left: 40px;background: #fcfcfc;border-radius: 20px;display: flex;align-items: center;box-shadow: 0px 15px 40px #7E6D5766;}.slider label {font-size: 24px;font-weight: 400;font-family: Open Sans;padding-left: 10px;color: black;}.slider input[type=\"range\"] {width: 420px;height: 2px;background: black;border: none;outline: none;}  */\r\n   \r\n.completed-icon-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  background-color: #ff6036;\r\n  color: white;\r\n  border-radius: 50%;\r\n  margin: auto; /* Center the icon horizontally */\r\n  font-size: 14px; /* Adjust the size of the icon as needed */\r\n}\r\n\r\n/* Mobile devices (screens less than 768px) */\r\n@media (max-width: 767px) {\r\n  .createCard {\r\n    display: block !important;\r\n  }\r\n}\r\n\r\n/* Tablet devices (screens between 768px and 1024px) */\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  .createCard {\r\n    display: block !important;\r\n  }\r\n}\r\n\r\n.theme-button:disabled{\r\n  background-color: #eead9b !important;\r\n}\r\n\r\n.printBtnn:disabled{\r\n  background-color: #ff603696;\r\n  color: white !important;\r\n  border: none;\r\n}\r\n\r\n.printBtnn:focus{\r\n  background-color: #f36037 !important;\r\n  color: white !important;\r\n  border: none;\r\n}\r\n.p-datatable-table thead tr th{\r\n  background-color: white !important;\r\n  /* border-bottom: #eaeaea solid 1px; */\r\n}\r\n.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover ,.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled){\r\n  background-color: #FDF5F2 !important;\r\n  color:#FF6036 !important\r\n}\r\n.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {\r\n  color: #f3633c !important;\r\n}\r\n.p-column-title{\r\n  font-size: 16px !important;\r\n  font-family: 'Poppins' !important;\r\n}\r\n.p-datatable .p-datatable-tbody > tr > td{\r\n  border-top: #eaeaea solid 1px;\r\n  margin: 5px;\r\n  font-size: 14px;\r\n  font-family: 'Poppins' !important;\r\n  font-weight: 400 !important;\r\n}\r\n.activity .theme-outline-btn{\r\n  min-width: 150px;\r\n  font-size: 12px !important;\r\n  padding: 5px !important;\r\n  font-weight: normal !important;\r\n}\r\n.textGry{\r\n  color:#ADADAD !important;\r\nfont-weight: 400 !important;\r\n}\r\n\r\n.p-paginator{\r\n  background-color: white !important;\r\n  border: none !important;\r\n  margin: 10px;\r\n}\r\n\r\n.p-paginator .p-paginator-pages .p-paginator-page.p-highlight{\r\n\r\n  background-color: #FDF5F2 !important;\r\n  color:#FF6036 !important\r\n}\r\n\r\n.p-highlight{\r\n\r\n  background-color: #FDF5F2 !important;\r\n  color:#FF6036 !important\r\n}\r\n\r\n.detail-block {\r\n  width: 70%;\r\n  margin: auto;\r\n  border: 1px solid #eaeaea;\r\n  background: #fff;\r\n  /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */\r\n}\r\n\r\n.detail-item {\r\n  border-bottom: 1px solid #eaeaea;\r\n  padding: 8px 0; /* Adjust padding to align vertically */\r\n  display: flex; /* Use flexbox for alignment */\r\n  justify-content: start; /* Align to the start of the flex container */\r\n  align-items: center; /* Center align vertically */\r\n}\r\n\r\n.detail-item > .label {\r\n  width: 45%; /* Adjust label width as needed */\r\n  text-align: start; /* Right align the label text */\r\n  margin-right: 10px; /* Spacing between label and text */\r\n  font-weight: normal;\r\n}\r\n\r\n.detail-item > .text {\r\n  text-align: left; /* Left align the text */\r\n  width: 65%; /* Adjust text width as needed */\r\n}\r\n\r\n/* Remove the bottom border for the last item */\r\n.detail-item:last-child {\r\n  border-bottom: none;\r\n}\r\n.datatable-row {\r\n  cursor: pointer;\r\n}\r\n\r\n.p-component-overlay{\r\n  background-color: transparent !important;\r\n}\r\n.custom-checkbox-align .checkbox input[type=\"checkbox\"] {\r\n  /* Adjust alignment and spacing as necessary */\r\n  vertical-align: middle;\r\n}\r\n\r\n.custom-checkbox-align .checkbox label {\r\n  margin-bottom: 0; /* Ensures label is aligned without extra space below */\r\n  vertical-align: middle;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.switches-container {\r\n  width: 16rem;\r\n  position: relative;\r\n  display: flex;\r\n  padding: 0;\r\n  position: relative;\r\n  background: var(--switches-bg-color);\r\n  line-height: 3rem;\r\n  border-radius: 3rem;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n/* input (radio) for toggling. hidden - use labels for clicking on */\r\n.switches-container input {\r\n  visibility: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n\r\n/* labels for the input (radio) boxes - something to click on */\r\n.switches-container label {\r\n  width: 50%;\r\n  padding: 0;\r\n  margin: 0;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  color: var(--switches-label-color);\r\n  font-weight: bold;\r\n}\r\n\r\n/* switch highlighters wrapper (sliding left / right) \r\n  - need wrapper to enable the even margins around the highlight box\r\n*/\r\n:root {\r\n  --switches-bg-color: #ff6036;\r\n  --switches-label-color: white ;\r\n  --switch-bg-color: white;\r\n  --switch-text-color:#ff6036 ;\r\n}\r\n.switch-wrapper {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 50%;\r\n  padding: 0.15rem;\r\n  z-index: 3;\r\n  transition: transform .5s cubic-bezier(.77, 0, .175, 1);\r\n  /* transition: transform 1s; */\r\n}\r\n\r\n/* switch box highlighter */\r\n.switchee {\r\n  border-radius: 3rem;\r\n  background: var(--switch-bg-color);\r\n  height: 100%;\r\n}\r\n\r\n/* switch box labels\r\n  - default setup\r\n  - toggle afterwards based on radio:checked status \r\n*/\r\n.switchee div {\r\n  width: 100%;\r\n  text-align: center;\r\n  opacity: 0;\r\n  display: block;\r\n  color: var(--switch-text-color) ;\r\n  transition: opacity .2s cubic-bezier(.77, 0, .175, 1) .125s;\r\n  will-change: opacity;\r\n  position: absolute;\r\n  font-weight: bold;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n/* slide the switch box from right to left */\r\n.switches-container input:nth-of-type(1):checked~.switch-wrapper {\r\n  transform: translateX(0%);\r\n}\r\n\r\n/* slide the switch box from left to right */\r\n.switches-container input:nth-of-type(2):checked~.switch-wrapper {\r\n  transform: translateX(100%);\r\n}\r\n\r\n/* toggle the switch box labels - first checkbox:checked - show first switch div */\r\n.switches-container input:nth-of-type(1):checked~.switch-wrapper .switchee div:nth-of-type(1) {\r\n  opacity: 1;\r\n}\r\n\r\n/* toggle the switch box labels - second checkbox:checked - show second switch div */\r\n.switches-container input:nth-of-type(2):checked~.switch-wrapper .switchee div:nth-of-type(2) {\r\n  opacity: 1;\r\n}\r\n.template .nav-link{\r\n  padding:5px 5px !important\r\n}\r\n.limitedmodel .btn-close{\r\n  top: 15px !important;\r\n  right: 13px !important\r\n}\r\n@media (max-width: 991px) {\r\n  .hide-on-mobile {\r\n    display: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
